import React, { useEffect, useRef, useState } from 'react';
import styles from './TraderCard.module.css';

const Logo = ({ logoUrl, setLogoUrl, setLogoFile, company, setCompany}) => {
    const fileInputRef = useRef(null);
    const [validFile, setvalidFile] = useState(true);
    
    useEffect(() => {
        if (!logoUrl) {
            setvalidFile(false);
        } else {
            const img = new Image();
            img.src = logoUrl;
            img.onload = () => setvalidFile(true);
            img.onerror = () => setvalidFile(false);
        }
    }, [logoUrl])
    
    function handleRemove() {
        setLogoUrl(null);
        setLogoFile(null);
    }
    
    function handleUpload() {
        fileInputRef.current?.click();
    }
    
    function handleFile(e) {
        e.preventDefault();
        const file = e.target.files?.[0];
        if (!file) return;
        const previewUrl = URL.createObjectURL(file);
        setLogoFile(file);
        setLogoUrl(previewUrl);
    }
    
    return (
        <div className={styles.master}>
            <div className={styles.company}>
                <div onClick={() => handleUpload()} className={styles.logo} style={{ backgroundImage: `url(${!validFile ? '/TraderCard/defaultLogo.png' : logoUrl})` }}>
                    <div className={styles.logoFilter}>
                        <input ref={fileInputRef} onChange={handleFile} type="file" accept="image/*" style={{ display: 'none' }} />
                    </div>
                </div>
                <div className={styles.name}>
                    <input value={company} onChange={(e) => setCompany(e.target.value)} className={styles.field} placeholder='Entrez le nom de votre entreprise'/>
                    <p className={styles.role}>Commerçant</p>
                </div>
            </div>
            <p onClick={() => handleRemove()} className={styles.delete}>Supprimer le logo</p>
        </div>
    );
};

export default Logo;